module.exports = __webpack_public_path__ + "static/flags/AG-c5d6641c1a925c23bfc4d0bf2e56f4b8.gif";